import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    fetchScreening,
    selectScreeningByIMO,
    selectScreeningError,
    selectScreeningLoading
} from "../features/screeningSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { ScreeningHeader } from "../components/screening/ScreeningHeader";
import { ScreeningTabs } from "../components/screening/ScreeningTabs";
import { useCapabilities } from "../hooks/user";
import { Capability } from "../types/inspections/UserCapabilities";
import { APIGradeType, MarketingPage } from "@idwal/idwal-react-components";
import { Button } from "primereact/button";
import { userSliceSelector } from "../features/userSlice";
import { ScreeningError } from "../components/screening/ScreeningError";
import { RequestReportModal } from "../components/screening/RequestReportModal";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";
import { sendGAEvent } from "../services/AnalyticsService";
import { GA_BUTTON_EVENT } from "../constants/GaEvents";
import { SCREENING_REQUEST_REPORT_MODAL, SCREENING_REQUEST_REPORT_MODAL_FORSALE } from "../utils/analytics";

export const Screening = () => {
    const dispatch = useAppDispatch();
    const { imo } = useParams();
    const { t } = useTranslation("locale");
    const { releaseRequestFullReport } = useFlags();
    const [requestReportVisible, setRequestReportVisible] = useState(false);

    const user = useAppSelector(userSliceSelector);
    const loading = useAppSelector(selectScreeningLoading);
    const error = useAppSelector(selectScreeningError);
    const data = selectScreeningByIMO(imo);

    const { capabilities } = useCapabilities([Capability.CAP_FLEETAPP_VIEW_SCREENING]);

    useEffect(() => {
        if (imo && user.UserToken) {
            dispatch(fetchScreening(imo));
        }
    }, [imo, user.UserToken]);

    if (!capabilities[Capability.CAP_FLEETAPP_VIEW_SCREENING] && !loading) {
        return (
            <div className="h-full flex flex-column align-items-center justify-content-center">
                <div id="marketing-container">
                    <MarketingPage
                        type="screening"
                        learnMoreCallback={() => {}}
                        requestDemoCallback={() => {}}
                        showLogo={true}
                    />
                </div>
            </div>
        )
    }

    if (error) {
        return <ScreeningError />
    }

    const showRequestReport = releaseRequestFullReport && data?.grade_type === APIGradeType.INSPECTED;
    const forSale = data?.for_sale ?? false;
    return (
        <div className={"inspection-page-wrapper"}>
            {requestReportVisible && data && (
                <RequestReportModal data={data} onClose={() => setRequestReportVisible(false)} />
            )}
            <div>
                <ScreeningHeader data={data} loading={loading} forSale={forSale} />
                <ScreeningTabs
                    data={data}
                    loading={loading}
                    tabBarAction={showRequestReport ? (
                        <Button
                            label={t("screening.accessFullReport")}
                            icon="pi pi-send"
                            iconPos="left"
                            style={{ padding: "0.4rem 0.75rem", marginBottom: "0.75rem" }}
                            onClick={() => {
                                sendGAEvent(GA_BUTTON_EVENT, forSale ? SCREENING_REQUEST_REPORT_MODAL_FORSALE : SCREENING_REQUEST_REPORT_MODAL);
                                setRequestReportVisible(true);
                            }}
                        />
                    ) : undefined}
                />
            </div>
        </div>
    );
};
